import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const notAuthGuard = async () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (await authService.isLoggedIn()) {
    return router.parseUrl('/');
  }

  return true;
}; 